<script>
import { dialogState, settleDialog } from '@/plugins/dialog'

const MODAL_NAME = 'app_dialog'

export default {
	name: 'AppDialog',
	data() {
		return {
			modalName: MODAL_NAME,
			state: dialogState,
		}
	},
	computed: {
		isConfirm() {
			return this.state.kind === 'confirm'
		},
		confirmLabel() {
			return this.state.confirmText || this.$t('button.confirm')
		},
		cancelLabel() {
			return this.state.cancelText || this.$t('button.cancel')
		},
	},
	watch: {
		'state.visible'(visible) {
			if (visible) {
				this.$modal.show(MODAL_NAME)
			} else {
				this.$modal.hide(MODAL_NAME)
			}
		},
	},
	methods: {
		confirm() {
			settleDialog(true)
		},
		// Крестик, клик по оверлею и Esc — то же, что «Отмена»
		cancel() {
			settleDialog(false)
		},
	},
}
</script>

<template>
	<modal
		class="modal__block modal__block--middle app-dialog"
		:class="state.variant ? 'modal__block--' + state.variant : ''"
		:name="modalName"
		:width="550"
		:max-width="550"
		:adaptive="true"
		height="auto"
		@closed="cancel"
	>
		<div class="modal__block--wrapper">
			<div class="modal__block--close" @click="cancel">
				<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.5 7.5l-15 15M7.5 7.5l15 15" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
			</div>
			<div class="modal__wrapper">
				<div class="modal__header">
					<div class="modal__title">{{ state.title }}</div>
				</div>
				<div class="modal__content">
					<div class="modal__form">
						<p v-if="state.text" class="app-dialog__text">{{ state.text }}</p>
						<div class="block__row">
							<template v-if="isConfirm">
								<div class="block__row--left">
									<button class="block__item" type="button" @click.prevent="confirm">
										<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.024 12.976l4.952-4.952m0 4.952L8.024 8.024M10.5 19.25c4.813 0 8.75-3.938 8.75-8.75 0-4.813-3.938-8.75-8.75-8.75-4.813 0-8.75 3.938-8.75 8.75 0 4.813 3.938 8.75 8.75 8.75z" stroke="#DF4242" stroke-linecap="round" stroke-linejoin="round"/></svg>
										{{ confirmLabel }}
									</button>
								</div>
								<div class="block__row--right">
									<button
										class="block__item block__item--blue"
										type="button"
										@click.prevent="cancel"
									>
										{{ cancelLabel }}
									</button>
								</div>
							</template>
							<button
								v-else
								class="block__item block__item--blue"
								type="button"
								@click.prevent="cancel"
							>
								{{ state.confirmText || $t('button.ok') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<style scoped>
.app-dialog .modal__block--close svg {
	width: 20px;
	height: 20px;
}

.app-dialog .block__item svg {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
}

.app-dialog__text {
	margin-bottom: 25px;
	font-size: 15px;
	line-height: 1.5;
	color: #475f84;
	text-align: center;
}

.app-dialog .block__item {
	background: transparent;
	border: none;
	padding: 0;
	text-align: left;
}

/* На узких экранах кнопки встают в столбик, иначе «Отмена» уезжает за край */
@media (max-width: 575px) {
	.app-dialog .modal__form {
		padding: 20px 20px 30px 20px;
	}

	.app-dialog .modal__header {
		padding: 15px 20px;
	}

	.app-dialog .block__row {
		flex-direction: column;
		gap: 16px;
	}

	.app-dialog .block__row--right {
		margin-left: 0;
	}

	.app-dialog .block__item {
		justify-content: center;
	}
}
</style>
